<template>
  <div class="userTop-selector dropdown" v-dropdown.closeOnMenuClick>
    <a class="userTop-selector-button dropdown-toggle" href="#">
       <span class="fa fa-2x fa-user text-white"></span>
    </a>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item">
        <i class="vuestic-icon vuestic-icon-settings"></i>
        <span class="dropdown-item-text ellipsis">
          {{ `userTop.profile` | translate }}
        </span>
      </a>
      <a class="dropdown-item">
        <i class="vuestic-icon vuestic-icon-auth"></i>
        <span class="dropdown-item-text ellipsis">
          <router-link class="plain-link" to="/auth/login">{{'userTop.logout' | translate}}</router-link>
        </span>
      </a>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'user-menu',
  }
</script>

<style lang="scss">
  @import "../../../sass/variables";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .userTop-selector {
    display: flex;
    max-width: 100%;
    height: 100%;
    padding: 0;
    flex-basis: 0;
    flex-grow: 1;
    align-items: center;
    justify-content: center;

    .userTop-selector-button {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .flag-icon-large {
      width: 31px;
      height: 23px;
    }

    .flag-icon-small {
      min-width: 22px;
      height: 17px;
    }

    .dropdown-toggle {
      padding: 0;

      &:after {
        display: none;
      }
    }

    &.show {
      &:after {
        position: absolute;
        right: calc(50% - 10px);
        bottom: -$dropdown-mobile-show-b;
        display: block;
        width: 0;
        height: 0;
        content: '';
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid $darkest-gray;
        z-index: 2;
      }

      .dropdown-menu {
        left: auto;
        margin-top: $dropdown-mobile-show-b;

        &.last {
          right: 0;
        }

        @include media-breakpoint-up(lg) {
          right: auto;
          left: 12px;
          margin-top: 12px;
        }
      }
    }

    .dropdown-menu {
      min-width: 8rem;
      max-width: 11rem;
      margin-top: $dropdown-show-b;
      padding: 0;
      background-color: $dropdown-background;
      box-shadow: $dropdown-box-shadow;

      @include media-breakpoint-up(lg) {
        top: 42px;
      }
    }

    .dropdown-item {
      display: flex;
      align-items: center;
      height: 38px;
      padding: 9px 12px;
      color:#fff;

      &.active {
        color: $theme-red;
        background-color: $darkest-gray;
      }

      &:hover {
        background-color: $almost-black;
      }

      &:last-child {
        padding-top: 8px;
        padding-bottom: 10px;
      }
    }

    .dropdown-item-text {
      padding-left: 12px;
      font-size: $font-size-base;
      line-height: 1.25;
      .plain-link{color:$white}
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/navbar/UserMenu.vue